import { FIREBASE_API_KEY } from './env'

const firebaseConfig = {
    apiKey: FIREBASE_API_KEY,
    authDomain: 'kaivo-e7185.firebaseapp.com',
    projectId: 'kaivo-e7185',
    storageBucket: 'kaivo-e7185.appspot.com',
    messagingSenderId: '98683807901',
    appId: '1:98683807901:web:c2fb70154b9aee78a9cc74'
}

export default firebaseConfig